import { Wrench, Phone, MessageCircle, CheckCircle2 } from "lucide-react";
import SEO from "../components/SEO";
import { ASSETS, BUSINESS, MOTO_SERVICES } from "../lib/data";

export default function OfficinaMoto() {
  return (
    <>
      <SEO
        title="Officina Scooter e Moto Roma Nord | Il Velocipede - Nuovo Salario"
        description="Officina specializzata per scooter e moto a Roma Nord. Tagliandi, diagnosi elettronica, riparazioni, revisione ministeriale. Assistenza Piaggio e Kymco autorizzata."
      />

      {/* HERO */}
      <section className="relative overflow-hidden bg-slate-900 text-white" data-testid="moto-hero">
        <div className="absolute inset-0">
          <img src={ASSETS.workshopScooter} alt="Officina scooter Roma Nord" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#013368] via-[#013368]/85 to-transparent" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
          <div className="max-w-3xl">
            <span className="text-[#fd0100] text-xs uppercase tracking-[0.22em] font-semibold flex items-center gap-2">
              <Wrench className="w-4 h-4" /> Officina specializzata
            </span>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
              Officina Scooter e Moto a Roma Nord
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-200 leading-relaxed">
              Tagliandi, diagnosi elettronica, riparazioni meccaniche e revisione ministeriale. Assistenza Piaggio e Kymco autorizzata nel quartiere Nuovo Salario.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={`https://wa.me/${BUSINESS.whatsappRaw}?text=Salve%2C%20vorrei%20prenotare%20un%20intervento%20in%20officina`} target="_blank" rel="noopener noreferrer" data-testid="moto-cta-prenota" className="btn-primary inline-flex items-center gap-2 px-6 py-3.5 rounded-full font-semibold text-sm">
                <MessageCircle className="w-4 h-4" /> Prenota un Intervento
              </a>
              <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="moto-cta-call" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full font-semibold text-sm bg-white text-[#013368] hover:bg-slate-100 transition">
                <Phone className="w-4 h-4" /> {BUSINESS.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES GRID */}
      <section className="py-20 md:py-28 bg-white" data-testid="moto-services">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-14">
            <div className="overline">Tutti i servizi</div>
            <div className="divider-red mt-3 mb-6" />
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
              Cosa facciamo per il tuo scooter e la tua moto
            </h2>
            <p className="mt-4 text-slate-600">
              Officina completa con strumenti diagnostici di ultima generazione, meccanici qualificati e ricambi originali.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {MOTO_SERVICES.map((s, i) => (
              <div key={i} data-testid={`moto-service-${i}`} className="flex items-start gap-3 bg-slate-50 border border-slate-200 rounded-xl p-5 hover:border-[#013368] hover:bg-white transition-all">
                <CheckCircle2 className="w-5 h-5 text-[#fd0100] shrink-0 mt-0.5" />
                <span className="text-slate-800 font-medium text-sm">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEO TEXT */}
      <section className="py-20 md:py-28 bg-slate-50" data-testid="moto-seo">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="overline">Roma Nord</div>
          <div className="divider-red mt-3 mb-6" />
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Assistenza Piaggio e Kymco autorizzata a Roma
          </h2>
          <div className="mt-8 space-y-5 text-slate-600 leading-relaxed">
            <p>
              La nostra <strong>officina scooter a Montesacro e Nuovo Salario</strong> è il punto di riferimento per chi cerca un'assistenza qualificata, rapida e onesta. Eseguiamo tagliandi periodici secondo le specifiche della casa madre, diagnosi elettronica completa, riparazioni meccaniche e impiantistiche.
            </p>
            <p>
              Siamo <strong>centro assistenza Piaggio Roma</strong> e <strong>centro assistenza Kymco Roma</strong>: significa che usiamo procedure ufficiali, software diagnostici autorizzati e ricambi originali. Non improvvisiamo: ogni intervento viene documentato e il cliente riceve preventivo dettagliato prima di iniziare i lavori.
            </p>
            <p>
              Tra i nostri servizi più richiesti ci sono la <strong>preparazione alla revisione ministeriale</strong>, la <strong>sostituzione pneumatici</strong> con bilanciatura, il <strong>cambio olio e filtri</strong>, la sostituzione delle <strong>batterie</strong>, la revisione completa dell'<strong>impianto frenante</strong> e il controllo delle <strong>sospensioni</strong>.
            </p>
            <p>
              Cerchi un <strong>meccanico scooter a Roma</strong> di fiducia? Prenota un intervento via WhatsApp: ti diamo un appuntamento veloce e, dove possibile, lavoriamo nella stessa giornata per restituirti il mezzo nel minor tempo possibile.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
